import Vue from "vue"
import events from "@/bl-events"
import OrderCta from "@/shared/order-cta"
import "@/modules/load-plans"

events.on("plans:ready", ({ plans }) => {
  const ctas = document.querySelectorAll(".order-cta-vue")

  ctas.forEach((el) => {
    const { copy, eventCategory, clickAction } = el.dataset
    const planDuration = parseInt(el.dataset.planDuration)
    const plan = plans.find((p) => p.plan.duration === planDuration)

    new Vue({
      name: "OrderCta",
      el,
      render: (h) =>
        h(OrderCta, {
          props: {
            plan,
            copy,
            eventCategory,
            clickAction
          }
        })
    })
  })
})
